import { FC } from 'react';
import { Tag } from 'antd';
import { convertSnakeCaseToTitleCase, getStatusColor } from 'utils/string.utils';

interface StatusTagProps {
  value?: string;
  size?: 'small' | 'default';
  onClick?: any;
  style?: React.CSSProperties;
}

const StatusTag: FC<StatusTagProps> = ({ value = '', size, style, onClick }) => {
  const isSmall = size === 'small';

  return (
    <Tag
      style={{
        marginRight: 0,
        lineHeight: isSmall ? '16px' : undefined,
        ...(value === 'hosting' ? { color: '#999999' } : {}),
        ...style,
      }}
      onClick={onClick}
      color={getStatusColor(value)}
    >
      {convertSnakeCaseToTitleCase(value === 'seed' ? 'master' : value)}
    </Tag>
  );
};

export default StatusTag;
